module.exports = __webpack_public_path__ + "images/motoshare9396b77db7341f39500bc146df402d72.png";